export interface VerticalState {
  topProgress: number;
  bottomProgress: number;
  ahead: boolean;
  entering: boolean;
  inside: boolean;
  contained: boolean;
  exiting: boolean;
  behind: boolean;
}

export const verticalState = (
  scrollY: number,
  containerHeight: number,
  elementTopPosition: number,
  elementHeight: number,
  marginTop = 0,
  marginBottom = marginTop,
): VerticalState => {
  const topProgress = getTopProgress();
  const bottomProgress = getBottomProgress();

  return {
    topProgress,
    bottomProgress,
    ahead: topProgress < 0,
    entering: topProgress > 0 && topProgress < 1 && bottomProgress < 0,
    inside: topProgress > 0 && bottomProgress < 1,
    contained: (topProgress < 1 && bottomProgress > 0) || (topProgress > 1 && bottomProgress < 0),
    exiting: topProgress > 1 && bottomProgress > 0 && bottomProgress < 1,
    behind: bottomProgress > 1,
  };

  /**
   * Position of the top border of the element depending on the viewport visibility
   * @returns {number} 0 => bottom of the viewport, 1 => top of the viewport
   */
  function getTopProgress(): number {
    return 1 - (elementTopPosition - (scrollY + marginTop)) / (containerHeight - marginTop - marginBottom);
  }

  /**
   * Position of the bottom border of the element depending on the viewport visibility
   * @returns {number} 0 => bottom of the viewport, 1 => top of the viewport
   */
  function getBottomProgress(): number {
    return (
      1 - (elementTopPosition + elementHeight - (scrollY + marginTop)) / (containerHeight - marginTop - marginBottom)
    );
  }
};
